import React from 'react';
import './LogoSpinner.css';

interface LogoSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  className?: string;
  text?: string;
}

const LogoSpinner: React.FC<LogoSpinnerProps> = ({ 
  size = 'medium', 
  className = '', 
  text 
}) => {
  return (
    <div className={`logo-spinner logo-spinner--${size} ${className}`}>
      <div className="logo-spinner__container">
        <img 
          src="/images/logo/tfr.avif" 
          alt="The Frosting Room" 
          className="logo-spinner__logo"
        />
      </div>
      {text && <p className="logo-spinner__text">{text}</p>}
    </div>
  );
};

export default LogoSpinner;
